/*
 * @Author: Teemo Ding
 * @Date: 2021-10-14 13:22:05
 * @LastEditTime: 2021-10-15 15:11:00
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/SalesChannelSelection/index.tsx
 */
import { Modal, ModalFooter } from '@/src/components/Antd';
import { useRequest } from 'ahooks';
import { cloneDeep } from 'lodash';
import React, { useMemo, useState } from 'react';
import { SizeFittingTable } from 'src/components/Antd';
import _Query from 'src/constrains/Query1';
import { useI18n } from 'src/hooks/useRouterChange';
import {
  getLegalPages, // deleteLegalPage
} from 'src/request/salesChannel/legal';
import { i18nGet } from 'src/tools/tools';
import { columns } from './config';
import css from './css.module.less';

const LegalPageSelection = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { visible, onCancel, onOk, salesChannelUuid, onBack } = props;
  const [searchCondition, setSearchCondition] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  //   const [salesChannels, setSalesChannels] = React.useState<any[]>([]);
  const { loading, data } = useRequest(() => getLegalPages(salesChannelUuid));
  //
  const { summaryList = [], timezoneInGmt }: any = data || {};

  const onOkPress = () => {
    onOk(salesChannelUuid, selectedRowKeys);
  };

  const legalPages = useMemo(() => {
    return summaryList.filter((o) =>
      searchCondition.every((item) => {
        return (
          o.name.toLowerCase().indexOf(item.value.toLowerCase()) >= 0 ||
          o.remarks.toLowerCase().indexOf(item.value.toLowerCase()) >= 0
        );
      }),
    );
  }, [searchCondition]);

  const onSelectChange = (value, select) => {
    setSelectedRowKeys(value);
  };

  const rowSelection = {
    selectedRowKeys: selectedRowKeys,
    onChange: onSelectChange,
    type: 'checkbox',
    hideSelectAll: true,
  };
  const displayBody = () => {
    return (
      <div className={css.table}>
        <SizeFittingTable
          rowKey='uuid'
          pagination={false}
          id='legalPagesSelectionTable'
          columns={columns(timezoneInGmt, { getI18n })}
          className={css.salesChannelSelectionTable}
          dataSource={searchCondition.length ? legalPages : summaryList}
          rowSelection={rowSelection}
          loading={loading}
          scroll={{ y: 470 }}
        />
      </div>
    );
  };

  return (
    <Modal
      title={getI18n('legalPage.index.selectLegalPages')}
      visible={visible}
      width={900}
      onCancel={onCancel}>
      <div className={css.queryContainer}>
        <_Query
          onSearchChange={(e) => {
            const _search = cloneDeep(searchCondition);
            _search.push(e);
            setSearchCondition(_search);
          }}
          onTagClose={(e) => {
            let _searchConditions = cloneDeep(searchCondition);
            const { value } = e;

            _searchConditions = _searchConditions.filter((i) => {
              const { value: _value } = i;
              return _value !== value;
            });
            setSearchCondition(_searchConditions);
          }}
          data={{ search: searchCondition }}
        />
        {displayBody()}
      </div>
      <ModalFooter
        front={
          <div className={css.footerTip}>{`${
            (selectedRowKeys || []).length
          } ${getI18n('general.itemsselected')}`}</div>
        }
        okText={getI18n('general.duplicate')}
        cancelText={getI18n('general.back')}
        hideOkButton={!selectedRowKeys.length}
        okClassName={css.okBtn}
        onOk={onOkPress}
        onCancel={onBack}
      />
    </Modal>
  );
};

export default LegalPageSelection;
